import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import { parseFlatArrayToTreeData } from '../utils/commonUtils';
import GroupCategory from '../models/GroupCategory';
import { merge, countBy } from 'lodash'

export function getGroupCategories(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CATEGORY_LIST,
        params: params,
        parser: data => groupCategoriesDataParser(data, params),
    }).get();
}

export function getAllGroupCategories(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CATEGORY_LIST_ALL,
        // params: params,
        parser: data => groupCategoryAllDataParser(data, params),
    }).get();
}

export function getGroupCategoryDetail(id, language) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CATEGORY_DETAIL,
        endpointParams: { id },
        headers: { 'accept-language': language },
        parser: data => new GroupCategory(data.data),
    }).get();
}

export function createGroupCategory(groupCategory) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CATEGORY_CREATE,
    }).post(groupCategory.export());
}

export function updateGroupCategory(groupCategory) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CATEGORY_UPDATE,
    }).put(groupCategory.export());
}

export function deleteGroupCategory(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CATEGORY_DELETE,
        endpointParams: { id },
    }).delete();
}

export function createGroupCategoryTranslate(groupCategory) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CATEGORY_TRANSLATE_CREATE,
    }).post(groupCategory.export(true).translate());
}

export function updateGroupCategoryTranslate(groupCategory) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CATEGORY_TRANSLATE_UPDATE,
    }).put(groupCategory.export(true).translate());
}

export function deleteGroupCategoryTranslate(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CATEGORY_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

function groupCategoriesDataParser(data = {}, params = {}) {
    const newParams = merge(params, { ...data, setBackup: true })
    return {
        ...newParams,
        result: (data.data || []).map(item => new GroupCategory(item))
    }
}

function groupCategoryAllDataParser(data = {}, params = {}) {
    const dataArray = params.excludedId ? (data.data || []).filter(item => item.id !== params.excludedId) : (data.data || [])
    const arrayCate = params.withoutChildren ? (dataArray || []).filter(item => !item.parentId || item.parentId === undefined) : (dataArray || [])
    const categoryTree = params.withoutChildren ? arrayCate : parseFlatArrayToTreeData(dataArray || [], 'parentId', 'children', 'id', null);
    return categoryTree.map(item => {
        const cate = new GroupCategory(item);
        if (params.withoutChildren) cate.children = undefined;
        return cate;
    });
}